import React from "react";
import "./RoboTaxiPopup.css";
import {
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText
} from "@mui/material";

const RobotaxiPopNew = ({
  roboTaxiAlert = false,
  selectedPSL = [],
  setSelectedPSL = () => {},
  pslList = [],
  roboTaxiCountError = "",
  handleSaveLimit = () => {},
  setRoboTaxiPopup = () => {},
  setRoboTaxis = () => {},
  setSelectedRoboTaxiOption = () => {},
  setRoboTaxiLimit = () => {}
}) => {

  const handleCancel = () => {
    setRoboTaxiPopup(false);
    setRoboTaxis(false);
    setSelectedRoboTaxiOption("");
    setRoboTaxiLimit(0);
    setSelectedPSL([]);
  };

  return (
    <>
      {roboTaxiAlert && (
        <div className="popup-container">
          <div className="popup">

            <span className="heading-title">
              Assign Spaces for RoboTaxis
            </span>

            <div className="popup-content-text">
              <p><strong>You’ve marked parking spaces</strong></p>
              <p>Select Parking Spaces for RoboTaxi use.</p>
            </div>

            {/* Parking Spaces */}
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <label style={{ fontWeight: 600, width: 140 }}>
                Parking Spaces <span style={{ color: "red" }}>*</span>
              </label>

              <FormControl className="mui-select-small"
                sx={{
                  width: 180,
                  background: "white",
                  borderRadius: "6px",
                  "& .MuiOutlinedInput-root": { paddingRight: "8px" },
                  "& fieldset": { border: "1px solid #ccc" },
                  "&:hover fieldset": { borderColor: "#999" }
                }}
                >
                <Select
                  multiple
                  displayEmpty
                  value={selectedPSL}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (value.includes("ALL")) {
                      setSelectedPSL(pslList.map(p => p.label));
                      return;
                    }
                    setSelectedPSL(value);
                  }}
                  renderValue={(selected) =>
                    selected.length === 0
                      ? "Select PSLs"
                      : selected.length === pslList.length
                        ? "All PSLs"
                        : selected.join(", ")
                  }
                >
                  <MenuItem value="ALL">
                    <Checkbox
                      checked={selectedPSL.length === pslList.length && pslList.length > 0}
                    />
                    <ListItemText primary="All PSLs" />
                  </MenuItem>

                  {pslList.map((p) => (
                    <MenuItem key={p.id} value={p.label}>
                      <Checkbox checked={selectedPSL.includes(p.label)} />
                      <ListItemText primary={p.label} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            {/* Error */}
            {roboTaxiCountError && (
              <div className="robotaxi-error">
                {roboTaxiCountError}
              </div>
            )}

            {/* Buttons */}
            <button className="add-property-btns" onClick={handleSaveLimit}>
              Save Limit
            </button>
            &nbsp;&nbsp;
            <button className="cancel-buttons" onClick={handleCancel}>
              Cancel
            </button>

          </div>
        </div>
      )}
    </>
  );
};

export default RobotaxiPopNew;
